import React from 'react';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';

import { ButtonIcon } from '@vds/button-icons';
import { Icon } from '@vds/icons';
import { useStore } from 'react-redux';
import { store } from '../../../../configureStore';
import { goToProcessStep } from '../../../../redirection';

const EditButtonIcon = ({ itemDesc, targetName }) => {
  const history = useHistory();
  const existingState = useStore().getState();
  const { currentView } = existingState;

  const handleEditRedirect = (pageName) => {
    if (pageName === 'Plan') {
      history.push('progressiveplan.html');
      store.dispatch({ type: 'UPDATE_PLANS_ACCORD_STATUS', response: true });
      goToProcessStep(currentView, history, false, false, true);
    } else if (pageName === 'Setup') {
      history.push('setup.html');
      goToProcessStep(currentView, history, false, false, false, true);
    }
  };

  return (
    <ButtonIcon
      kind="ghost"
      size="small"
      surface="light"
      surfaceType="colorFill"
      ariaLabel={itemDesc}
      onClick={(e) => {
        handleEditRedirect(targetName);
        if (e) {
          e.preventDefault();
        }
      }}
      data-track={`'{"type":"link","name":"${targetName}|express checkout","data":{"page":{"throttle":"nsa version|vhi|ec y"},"target":{"sandBox":"FWA_Express_T_Checkout"}}}'`}   
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          handleEditRedirect(targetName);
          if (e) {
            e.preventDefault();
          }
        }
      }}
      renderIcon={(props) => <Icon name="right-arrow" {...props} />}
    />
  );
};

EditButtonIcon.propTypes = {
  itemDesc: PropTypes.string,
  targetName: PropTypes.string,
};
export default EditButtonIcon;
